'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

exports['default'] = createProvider;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _utilsShallowEqual = require('../utils/shallowEqual');

var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);

var _utilsIsPlainObject = require('../utils/isPlainObject');

var _utilsIsPlainObject2 = _interopRequireDefault(_utilsIsPlainObject);

var _utilsHasEmptyIntersection = require('../utils/hasEmptyIntersection');

var _utilsHasEmptyIntersection2 = _interopRequireDefault(_utilsHasEmptyIntersection);

var _utilsSharedKeys = require('../utils/sharedKeys');

var _utilsSharedKeys2 = _interopRequireDefault(_utilsSharedKeys);

function createProvider(React) {
  var Component = React.Component;
  var PropTypes = React.PropTypes;

  return (function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      return { provided: this.state.provided };
    };

    _createClass(Provider, null, [{
      key: 'contextTypes',
      value: {
        provided: PropTypes.object
      },
      enumerable: true
    }, {
      key: 'childContextTypes',
      value: {
        provided: PropTypes.object.isRequired
      },
      enumerable: true
    }, {
      key: 'propTypes',
      value: {
        children: PropTypes.func.isRequired,
        provide: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
      },
      enumerable: true
    }]);

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      _Component.call(this, props, context);
      var provided = this.providedFromPropsAndContext(props, context);
      this.state = { provided: provided };
    }

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
      var provided = this.state.provided;

      var nextProvided = this.providedFromPropsAndContext(nextProps, nextContext);
      if (_utilsShallowEqual2['default'](provided, nextProvided)) {
        return;
      }
      this.setState({ provided: nextProvided });
    };

    Provider.prototype.providedFromPropsAndContext = function providedFromPropsAndContext(props, context) {
      var isNestedProvider = _utilsIsPlainObject2['default'](context.provided);
      var parentProvided = isNestedProvider ? context.provided : {};

      if (isNestedProvider) {
        _invariant2['default'](_utilsIsPlainObject2['default'](parentProvided), 'This Provider appears to be nested inside another provider but received a parent `provided` ' + 'is not a plain Object. `provided` must be always be a plain Object. %s', parentProvided);
      }

      var provide = props.provide;

      var provider = provide;

      if (_utilsIsPlainObject2['default'](provide)) {
        provider = function (parentProvided) {
          return _extends({}, parentProvided, provide);
        };
      }

      var provided = provider(parentProvided);

      _invariant2['default'](_utilsIsPlainObject2['default'](provided), 'This Provider is attempting to provide something other than a plain Object. ' + 'the `provide` prop must either be a plain object itself or a function that returns ' + 'a plain Object. `provide` is or returned %s', provided);

      return provided;
    };

    Provider.prototype.isNested = function isNested() {};

    Provider.prototype.render = function render() {
      var children = this.props.children;

      return children();
    };

    return Provider;
  })(Component);
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-tunnel/lib/components/createProvider.js
// module id = 1052
// module chunks = 4